var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-section',{attrs:{"background":"white"}},[_c('b-container',[_c('h2',{staticClass:"title",staticStyle:{"text-align":"center","font-size":"30px"}},[_vm._v("Всичко в три лесни стъпки")]),_c('base-step-by-step')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }